import React from 'react';

export default function BlockContentHorizontalRule() {
  return (
    <hr
      aria-hidden="true"
      className="block bg-background border-0 h-0.5 my-6 md:my-10 bg-gradient-to-l from-border/0 from-5% via-border via-50% to-border/0 to-95%"
    />
  );
}
